import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { REG_EXP } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { NAME_PATTERNS } from '@com-delta-idp/mnx-sitewide-shared-utils';

export const getFormErrorCount = (
  form: UntypedFormGroup,
  errorCount = 0
): number => {
  Object.keys(form.controls).forEach((field) => {
    const control = form.controls[field];
    if (control instanceof UntypedFormControl) {
      if (control.errors) {
        errorCount += 1;
      }
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof UntypedFormGroup) {
      getFormErrorCount(control, errorCount);
    }
  });
  return errorCount;
};

export const CONFIRMATION_NUM_VALIDATORS = [
  Validators.required,
  Validators.pattern(REG_EXP.CONFIRMATION_NUMBER)
];

export const CREDIT_CARD_VALIDATORS = [
  Validators.required,
  Validators.pattern(REG_EXP.CREDITCARD_NUMBER)
];

export const TICKET_NUMBER_VALIDATORS = [
  Validators.required,
  Validators.pattern(REG_EXP.TICKET_NUMBER)
];

export const NAME_VALIDATORS = [
  Validators.required,
  Validators.pattern(REG_EXP.INPUT_NAME_50)
];

export const FIRST_NAME_VALIDATORS = [
  Validators.required,
  Validators.pattern(NAME_PATTERNS.FIRST_NAME_REGEX)
];

export const LAST_NAME_VALIDATORS = [
  Validators.required,
  Validators.pattern(NAME_PATTERNS.LAST_NAME_REGEX)
];

export const myTripFormGroup = (
  nameLengthConfig?: boolean
): UntypedFormGroup => {
  return new UntypedFormBuilder().group({
    confirmationNo: [null, CONFIRMATION_NUM_VALIDATORS],
    eTicketNo: [null, []],
    creditCardNo: [null, []],
    firstName: [
      null,
      nameLengthConfig ? FIRST_NAME_VALIDATORS : NAME_VALIDATORS
    ],
    lastName: [null, nameLengthConfig ? LAST_NAME_VALIDATORS : NAME_VALIDATORS],
    searchType: new UntypedFormControl()
  });
};
